import React from 'react';
import Select, { components } from 'react-select';
import { useDataContext } from '../context/data';
import translations from '../constants/translations.json';

const defaultOptions = [
  { value: 'option1', label: 'Option 1' },
  { value: 'option2', label: 'Option 2' },
  { value: 'option3', label: 'Option 3' },
];

// Custom dropdown indicator
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <div
        className="flex items-center justify-center rounded-full bg-primary"
        style={chevronStyles}
      >
        <i className="fas fa-chevron-down" />
      </div>
    </components.DropdownIndicator>
  );
};

const chevronStyles = {
  background: '#95c11f',
  color: '#fff',
  width: '34px',
  height: '34px',
};

// Custom styles for react-select
const customStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: '30px', // rounded-full
    borderColor: '#f5f5f5',
    padding: '0 5px',
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    minHeight: 42,
    height: 42,
    boxShadow: 'none',
    '&:focus': {
      outline: 'none',
      borderColor: '#e5e5e5',
      backgroundColor: '#e5e5e5',
    },
    '&:hover': {
      borderColor: '#e5e5e5',
      backgroundColor: '#e5e5e5',
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#F3F4F6' : 'white',
    color: '#374151', // text-gray-700
    '&:hover': {
      backgroundColor: '#F9FAFB', // hover:bg-gray-50
    },
    cursor: 'pointer',
    padding: '8px 16px', // py-2 px-4
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '6px', // rounded-md
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // shadow-lg
  }),
  menuList: (base) => ({
    ...base,
    padding: '4px 0', // py-1
  }),
  singleValue: (base) => ({
    ...base,
    color: '#1f2937',
    fontWeight: 500,
    fontSize: '13px',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px 0 14px',
    fontSize: '13px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 0,
  }),
};

const CustomSelect = ({ value, onChange, placeholder, options, className }) => {
  const { language } = useDataContext();

  const selectOptions = options || defaultOptions;

  return (
    <Select
      placeholder={placeholder || translations[language]?.select_placeholder || 'VÃ¦lg...'}
      options={selectOptions}
      onChange={onChange}
      value={value}
      defaultValue={selectOptions[0]}
      styles={customStyles}
      components={{ DropdownIndicator }}
      isSearchable={false}
      className={className}
    />
  );
};

export { CustomSelect as Select };
